import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge about our custom Foundations box-shadow utilities
// (shadow-soft / elevated / glass / overlay) so that passing one via a
// component's `className` correctly overrides the shadcn default `shadow-sm`
// instead of being kept alongside it (which left the default winning).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: ["soft", "elevated", "glass", "overlay"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
